var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isFullyLoaded
    ? _c(
        "q-btn",
        _vm._b(
          {
            staticClass: "q-pl-lg q-pr-lg q-mr-lg",
            attrs: {
              "data-test": _vm.CypressTarget("Buy"),
              label: _vm.labelText,
              size: "17px",
              rounded: ""
            },
            on: {
              click: function($event) {
                _vm.$emit("addToCart")
              }
            }
          },
          "q-btn",
          _vm.quasarButtonProps,
          false
        ),
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }